import React from "react";
import { TouchableOpacity, StyleSheet } from "react-native";
import { Text } from 'react-native-paper';
import { useThemeSettings } from "../ThemeProvider";

const SelectionOption = ({
    label,
    selected,
    onPress
}: {
    label: string;
    selected: boolean;
    onPress: () => void;
}) => {

    const { theme } = useThemeSettings();
    return (
        <TouchableOpacity onPress={onPress} style={styles.option}>
            <Text style={[styles.optionText, { color: theme?.colors?.subtleText }, selected && { ...styles.selectedText, color: theme?.colors?.secondary }]}>
                {label}
            </Text>
            {selected && <Text style={styles.check}>✓</Text>}
        </TouchableOpacity>
    );
}

export default SelectionOption;

const styles = StyleSheet.create({
    option: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: 8,
    },
    optionText: {
        fontSize: 14,
        paddingRight: 5,
        lineHeight:20,
        fontWeight: 400,
    },
    selectedText: {
        fontWeight: 500,
    },
    check: {
        fontSize: 16,
        color: '#c57c37',
    },
});
